module.exports = __webpack_public_path__ + "img/plan.d6caa660.gif";